import axios from "axios";
import { jwtDecode } from "jwt-decode";

const api = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL ||
    "https://corporator-backend.onrender.com",

  headers: {
    "Content-Type": "application/json",
  },
});

/* ==========================================
   REQUEST INTERCEPTOR
========================================== */

api.interceptors.request.use(

  (config) => {

    const token = localStorage.getItem("token");

    if (token) {

      try {

        const decoded = jwtDecode(token);

        // Check if token expired
        if (decoded.exp * 1000 < Date.now()) {

          console.log("JWT Expired");

          localStorage.clear();

          window.location.replace("/");

          return Promise.reject(
            new Error("JWT Expired")
          );

        }

        config.headers.Authorization =
          `Bearer ${token}`;

      } catch (err) {

        console.error("Invalid JWT", err);

        localStorage.clear();

        window.location.replace("/");

        return Promise.reject(err);

      }

    }

    return config;

  },

  (error) => Promise.reject(error)

);

/* ==========================================
   RESPONSE INTERCEPTOR
========================================== */

api.interceptors.response.use(

  (response) => response,

  (error) => {

    const status = error.response?.status;

    const url = error.config?.url || "";

    // Don't redirect for login/auth endpoints
    if (
      (status === 401 || status === 403) &&
      !url.includes("/auth/login") &&
      !url.includes("/auth/register") &&
      !url.includes("/auth/request-otp") &&
      !url.includes("/auth/verify-otp")
    ) {

      console.log("Session Expired");

      localStorage.clear();

      window.location.replace("/");

    }

    return Promise.reject(error);

  }

);
export default api;